// import getBaseUrl from '@/lib/config';
import { SignUp } from '@clerk/clerk-react';

export default function SignUpPage() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-gray-50 dark:bg-gray-900">
      <SignUp
        routing="path"
        path="/sign-up"
        // redirectUrl={`${getBaseUrl()}/`}
        // afterSignUpUrl={`${getBaseUrl()}`}
      />
    </div>
  );
}
